// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetCostCenterDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class AssetCostCenterApiClient extends BaseCRUDApiClient<AssetCostCenterDto> {
  baseUrl = this.config.apiEndpoint + '/asset-cost-center';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
